module.exports = __webpack_public_path__ + "components/flag/static/square/bd-7bf20e8f37c247e30a2b7fe15bd7f44e.svg";